/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useEffect} from 'react'
import {Outlet, Route, Routes, Navigate} from 'react-router-dom'
import {Registration} from './components/Registration'
import {ForgotPassword} from './components/ForgotPassword'
import {ResetPassword} from './components/ResetPassword'
import {UpdatePassword} from './components/UpdatePassword'
import {Login} from './components/Login'
import {ConfirmEmail} from './components/ConfirmEmail'
import {ResendEmailConfirmation} from './components/ResendEmailConfirmation'
import {toAbsoluteUrl} from '../../../_metronic/helpers'
import {Card, Carousel} from 'react-bootstrap'

const AuthLayout = () => {
  useEffect(() => {
    document.body.classList.add('bg-body')
    return () => {
      document.body.classList.remove('bg-body')
    }
  }, [])

  return (
    <div
      id='auth'
      className='d-flex flex-column flex-xl-row flex-column-fluid bgi-size-cover bgi-position-x-end'
      style={{
        backgroundImage: `url(${toAbsoluteUrl('/media/patterns/pattern-1.jpg')})`,
      }}
    >
      <div className='d-flex flex-column flex-column-fluid flex-center' style={{background: `rgba(255, 255, 255, 0.1)`}}>
        <div className='d-flex flex-center flex-column flex-column-fluid p-10 p-xl-20'>
          <Card>
            <Card.Body className='p-lg-20'>
              <Outlet />
            </Card.Body>
          </Card>
        </div>
      </div>
      <div className='d-none d-xl-flex flex-column flex-center p-20 flex-grow-1'>
        <div className='d-flex flex-column gap-6 w-100 mw-1000px'>
          <div className='d-flex w-75 align-self-center'>
            <div className='separator separator-content mb-10 w-100'>
              <img alt='Logo' src={toAbsoluteUrl('/media/logos/logo_reversed.svg')} className='h-100px' />
            </div>
          </div>
          <div className='text-center'>
            <h1 className='fs-3x text-white lh-1'>GLC Demi Rakyat & Negara</h1>
            <span
              className='fs-2x text-white lh-1'
              style={{
                fontFamily: 'Rage',
              }}
            >
              Sinergi GDRN, Lestari Bersama
            </span>
          </div>
          <div className=''>
            <Carousel fade controls={false} indicators={false}>
              <Carousel.Item>
                <div
                  className='themed-border-radius'
                  style={{
                    height: 'calc(100vh * 0.4)',
                    backgroundImage: `url(${toAbsoluteUrl('/media/a1.jpg')})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center center',
                  }}
                ></div>
              </Carousel.Item>
              <Carousel.Item>
                <div
                  className='themed-border-radius'
                  style={{
                    height: 'calc(100vh * 0.4)',
                    backgroundImage: `url(${toAbsoluteUrl('/media/a2.jpg')})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center center',
                  }}
                ></div>
              </Carousel.Item>
              <Carousel.Item>
                <div
                  className='themed-border-radius'
                  style={{
                    height: 'calc(100vh * 0.4)',
                    backgroundImage: `url(${toAbsoluteUrl('/media/a3.jpg')})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center 30%',
                  }}
                ></div>
              </Carousel.Item>
            </Carousel>
          </div>
          <div className='text-center text-white w-75 align-self-center'>
            <p className='fs-6 fw-light'>
              GDRN was first established as The Government-Linked Companies (GLC) and Government-Linked Investment Companies (GLIC) Disaster Response
              Network (GDRN) to work with different partners. This is part of the efforts to coordinate humanitarian aid from various GLC and GLIC
              partners for those in need who were gravely affected by natural disasters as well as the COVID-19 pandemic.{' '}
            </p>
          </div>
          <div className='d-flex w-75 align-self-center'>
            <div className='separator w-100'></div>
          </div>
        </div>
      </div>
    </div>
  )
}

const AuthPage = () => {
  return (
    <Routes>
      <Route element={<AuthLayout />}>
        <Route path='login' element={<Login />} />
        <Route path='registration' element={<Registration />} />
        <Route path='forgot-password' element={<ForgotPassword />} />
        <Route path='reset-password' element={<ResetPassword />} />
        <Route path='confirm-email' element={<ConfirmEmail />} />
        <Route path='update-password' element={<UpdatePassword />} />
        <Route path='resend-email-confirmation' element={<ResendEmailConfirmation />} />
        <Route index element={<Login />} />
        <Route path='*' element={<Navigate to='/auth/login' replace/>} />
      </Route>
    </Routes>
  )
}

export {AuthPage}
